import { USER_ID } from '@/consts';
import { ConsigneePartial, ForwardingPaymentPartial, SenderPartial, ThirdPersonPartial, TransportationDetailsPartial } from '@/partials';
import { BACKEND } from '@/remotes';
import { getMonthString, getTime } from '@/utils/changeDate';
import { getArrayOfRules } from '@/utils/getDataForm';
import { Printer } from '@element-plus/icons-vue';
import { reactive, ref } from 'vue';
import * as rulesForm from './rulesForm';

import { getRaspiska } from '@/printing/consignmentNote/raspiska/getRaspiska';
import { getRaspiskaStyles } from '@/printing/consignmentNote/raspiskaStyles/getRaspiskaStyles';
import { getMarkingCards } from '@/printing/markingCards/MarkingCards/getMarkingCards';
import { getStylesMarkingCards4 } from '@/printing/markingCards/markingCards4/getStylesMarkingCards4';
import { getStylesMarkingCards8 } from '@/printing/markingCards/markingCards8/getStylesMarkingCards8';
import { useDataFormStore } from '@/stores/form';

export default {
  components: {
    SenderPartial,
    ConsigneePartial,
    ThirdPersonPartial,
    TransportationDetailsPartial,
    ForwardingPaymentPartial,
  },

  setup() {
    const dataForm = useDataFormStore();


    const ruleForm = reactive({
      applicationCargoPickup: dataForm.applicationCargoPickup,
      sender: dataForm.sender,
      consignee: dataForm.consignee,
      thirdPerson: dataForm.thirdPerson,
      services: dataForm.services,
      cargoInformation: dataForm.cargoInformation,
      payment: dataForm.payment,
    });

    const rules = reactive({
      // ...rulesForm,
      applicationCargoPickup: rulesForm.applicationCargoPickup(dataForm.applicationCargoPickup),
      sender: rulesForm.sender(dataForm.sender),
      consignee: rulesForm.consignee(dataForm.consignee),
      thirdPerson: rulesForm.thirdPerson(dataForm.thirdPerson),
      cargoInformation: rulesForm.cargoInformation(dataForm.cargoInformation),
      services: rulesForm.services(dataForm.services),
      payment: rulesForm.payment(dataForm.payment),
    });

    const formTabs = reactive({
      activeName: 'cargo-transportation-customer',
      tabs: ['cargo-transportation-customer', 'transportation-details', 'payment'],
      arrayFormTads: {
        counterparties: [...getArrayOfRules(dataForm.sender, 'sender'), ...getArrayOfRules(dataForm.consignee, 'consignee'), ...getArrayOfRules(dataForm.thirdPerson, 'thirdPerson')],
        transportationDetails: [
          ...getArrayOfRules(dataForm.applicationCargoPickup, 'applicationCargoPickup'),
          ...getArrayOfRules(dataForm.cargoInformation, 'cargoInformation'),
          ...getArrayOfRules(dataForm.services, 'services'),
        ],
      },
    });

    const switchingTabs = (increment) => {
      formTabs.activeName = formTabs.tabs[formTabs.tabs.indexOf(formTabs.activeName) + increment];
    };

    const ruleFormRef = ref();

    function parseObjectInNumber(obj) {
      return Object.entries(obj).reduce((accum, [key, value]) => {
        accum[key] = Number(value);
        return accum;
      }, {});
    }

    const parsePhoneNumber = (phone) => Number(phone.replace(/[^0-9]/g, ''));

    const alertOfApplicationSubmission = reactive({
      isVisiblePrint: false,
      isVisibleTalonsPrint: false,
      numberApplication: 0,
      pickupDate: 0,
      cargoStartTimePickup: '',
      cargoEndTimePickup: '',
      createTime: {
        day: '',
        month: '',
        year: '',
      },

      cargoCost: '',

      cashOnDelivery: '',
      cargoRedemptionSum: '',
      cargoRedemption: false,

      date: {
        day: '',
        month: '',
        year: '',
        time: '',
      },
      sender: {
        inn: '',
        city: '',
        name: '',
        phone: '',
        address: '',
        email: '',
      },
      consignee: {
        inn: '',
        city: '',
        name: '',
        phone: '',
        address: '',
        email: '',
      },
      customer: {
        inn: '',
        city: '',
        name: '',
        phone: '',
        address: '',
        email: '',
      },
      warmPlace: false,
      natureOfCargo: '',
      numberOfIdenticalLoads: '',
      typeOfPackaging: '',
      documentReturn: false,
    });

    function closePrintingModal() {
      alertOfApplicationSubmission.isVisiblePrint = false;
    }

    function closePrintingTalonsModal() {
      alertOfApplicationSubmission.isVisibleTalonsPrint = false;
    }

    function openPrintingTalonsModal() {
      alertOfApplicationSubmission.isVisibleTalonsPrint = true;
    }

    function parseDate(date) {
      return date < 10 ? `0${date}` : date;
    }

    function getTimeString(date) {
      const hours = date.getHours();
      const minutes = date.getMinutes();
      return `${parseDate(hours)}:${parseDate(minutes)}`;
    }

    function passDataPrint(data, customerAppliction, state) {
      alertOfApplicationSubmission.id = data.id;
      alertOfApplicationSubmission.numberApplication = data.number;
      alertOfApplicationSubmission.createTime.day = parseDate(new Date(data.createTime.slice(0, 10)).getDate());
      alertOfApplicationSubmission.createTime.month = parseDate(new Date(data.createTime.slice(0, 10)).getMonth());
      alertOfApplicationSubmission.createTime.year = parseDate(new Date(data.createTime.slice(0, 10)).getFullYear());
      alertOfApplicationSubmission.date.day = new Date(data.createTime).getDate();
      alertOfApplicationSubmission.date.month = getMonthString(Number(new Date(data.createTime).getMonth()));
      alertOfApplicationSubmission.date.year = new Date(data.createTime).getFullYear();
      alertOfApplicationSubmission.date.time = getTimeString(new Date(data.createTime));
      alertOfApplicationSubmission.cashOnDelivery = data.cashOnDelivery.sum;
      if (data.repurchaseCargo === null) {
        alertOfApplicationSubmission.cargoRedemptionSum = '';
      } else {
        alertOfApplicationSubmission.cargoRedemptionSum = data.repurchaseCargo.sum || 0;
        alertOfApplicationSubmission.cargoRedemption = data.repurchaseCargo.whoRepurchaseCargo == 1;
      }
      alertOfApplicationSubmission.cargoCost = data.cargoList[0].value;

      alertOfApplicationSubmission.sender = {
        inn: state.sender.corpClient.inn,
        city: state.transportation.cityFrom,
        name: state.sender.corpClient.inn === '' ? state.sender.name : state.sender.corpClient.title,
        phone: state.sender.phone,
        email: state.sender.email || '',
        address: data.pickUp ? data.pickUp.address.address : '',
        obligationPattern: state.sender.obligationPattern,
      };

      alertOfApplicationSubmission.consignee = {
        inn: state.consignee.corpClient.inn,
        city: state.transportation.cityTo,
        name: state.consignee.corpClient.inn === '' ? state.consignee.name : state.consignee.corpClient.title,
        phone: state.consignee.phone,
        email: state.consignee.email || '',
        address: state.delivery ? state.delivery.address.address : '',
        obligationPattern: state.consignee.obligationPattern,
      };
      alertOfApplicationSubmission.isDelivery = data.delivery ? true : false;

      if (customerAppliction === 'Отправитель') {
        alertOfApplicationSubmission.customer = alertOfApplicationSubmission.sender;
      } else if (customerAppliction === 'Получатель') {
        alertOfApplicationSubmission.customer = alertOfApplicationSubmission.consignee;
      } else {
        alertOfApplicationSubmission.customer = {
          inn: state.customer.corpClient.inn,
          name: state.customer.corpClient.inn === '' ? state.customer.name : state.customer.corpClient.title,
          phone: state.customer.phone,
          email: state.customer.email || '',
        };
      }

      alertOfApplicationSubmission.customerObligationPattern = state.customer.obligationPattern;

      alertOfApplicationSubmission.natureOfCargo = data.cargoList[0].cargoDescription;
      alertOfApplicationSubmission.warmPlace = data.cargoList[0].warmPlace;
      alertOfApplicationSubmission.numberOfIdenticalLoads = data.cargoList[0].numberOfIdenticalLoads;
      alertOfApplicationSubmission.quantityOfCargo = data.quantityOfCargo;
      alertOfApplicationSubmission.typeOfPackaging = checkTypesPackaging(data);

      alertOfApplicationSubmission.payment = { ...dataForm.payment };
      alertOfApplicationSubmission.documentReturn = data.documentReturn;

      alertOfApplicationSubmission.stCalc = {
        sumAddrPickUp: data.stCalc.sumAddrPickUp,
        sumCarrying: data.stCalc.sumCarrying,
        sumAddrDelivery: data.stCalc.sumAddrDelivery,
        sumPacking: data.stCalc.sumPacking,
        sumInsuranceForValue: data.stCalc.sumInsuranceForValue,
        sumGasolinePickUp: data.stCalc.sumGasolinePickUp,
        sumGasolineDelivery: data.stCalc.sumGasolineDelivery,
      };

      alertOfApplicationSubmission.sumInsuranceForValue = data.sumInsuranceForValue;
      alertOfApplicationSubmission.insuranceForValuePayer = data.insuranceForValuePayer;

      alertOfApplicationSubmission.extraServices = data.services;

      alertOfApplicationSubmission.consigneePaymentType = data.consigneePaymentType;
      alertOfApplicationSubmission.consigneeSumTotal = data.consigneeSumTotal;

      alertOfApplicationSubmission.customerPaymentType = data.customerPaymentType;
      alertOfApplicationSubmission.customerSumTotal = data.customerSumTotal;

      alertOfApplicationSubmission.senderPaymentType = data.senderPaymentType;
      alertOfApplicationSubmission.senderSumTotal = data.senderSumTotal;

      alertOfApplicationSubmission.isVisiblePrint = true;
    }

    function checkTypesPackaging(data) {
      const typePackaging = [
        { palletizing: 'Паллетирование' },
        { stretchFilm: 'Стретч-пленка' },
        { lathing: 'Обрешётка' },
        { poddon: 'Поддон' },
        { box25x18x10: 'Коробка 25x18x10' },
        { box38x30x23: 'Коробка 38x30x23' },
        { packet: 'Пакет' },
      ];
      let arrayTypes = [];
      for (const type of typePackaging) {
        data.cargoList[0][Object.keys(type)[0]] ? arrayTypes.push(Object.values(type)[0]) : 0;
      }
      return arrayTypes.length ? arrayTypes : 'Отказ';
    }

    function pagePrint(calculatedData) {
      console.log(calculatedData);
      const win = window.open();
      const head = `
        <head>
          <title>Печать!</title>
          ${getRaspiskaStyles()}
          <link href="https://fonts.cdnfonts.com/css/tt-norms" rel="stylesheet">
        </head>
      `;

      console.log('This is alert: ', alertOfApplicationSubmission);

      const body = `
        <body class="container">
          ${getRaspiska(alertOfApplicationSubmission)}
          ${getRaspiska(alertOfApplicationSubmission)}
        <script defer>
          document.fonts.ready.then(() => {
            window.print();
            setTimeout(window.close, 0);
          })
        </script>
        </body>
      `;
      const html = `<html>` + head + body + `</html>`;
      win.document.open();
      win.document.write(html);
      win.document.close();
      // alertOfApplicationSubmission.isVisiblePrint = false;
    }

    async function onMarkingCardPrint() {
      const styleCondition = alertOfApplicationSubmission.quantityTalons <= 4;
      try {
        let {
          data: { talons },
        } = await BACKEND.get(`/order/talons/${alertOfApplicationSubmission.id}?userid=${USER_ID}`);
        console.log('talons', talons);
        talons = talons.map((talon) => ({ ...talon, consigneeName: alertOfApplicationSubmission.consignee.name, senderName: alertOfApplicationSubmission.sender.name }));
        const win = window.open();
        const head = `
            <head>
              <title>Печать!</title>
              <link href="https://fonts.cdnfonts.com/css/tt-norms" rel="stylesheet">
              ${styleCondition ? getStylesMarkingCards4() : getStylesMarkingCards8()}
            </head>
          `;
        const body = `
            <body>
              <div class="wrapper">
                ${getMarkingCards(talons)}
              </div>
              <script defer>
                  document.fonts.ready.then(() => {
                    window.print();
                    setTimeout(window.close, 0);
                  })
              </script>
            </body>
          `;
        const html = `<html>` + head + body + `</html>`;
        win.document.open();
        win.document.write(html);
        win.document.close();
        // alertOfApplicationSubmission.isVisiblePrint = false;
      } catch (e) {
        console.log(e);
      }
    }

    // function checkNumberPhone(payer, phoneSender, phoneConsignee, isPay) {
    //   if (isPay && phoneConsignee === phoneSender) {
    //     return 'Получатель';
    //   }
    //   return payer;
    // }

    async function checkValidTab(arrayRules) {
      try {
        await ruleFormRef.value.validateField(arrayRules);
      } catch (e) {
        return false;
      }
      return true;
    }

    return {
      dataForm,

      alertOfApplicationSubmission,
      Printer,

      ruleFormRef,
      ruleForm,
      rules,

      formTabs,

      parseObjectInNumber,
      parsePhoneNumber,
      parseDate,
      closePrintingModal,
      closePrintingTalonsModal,
      openPrintingTalonsModal,

      clickFormButtonBack: function () {
        switchingTabs(-1);
      },

      clickFormButtonNext: async function (arrayRules) {
        const isValidForm = await checkValidTab(arrayRules);

        if (isValidForm) {
          await ruleFormRef.value.clearValidate();
          switchingTabs(1);
        }
      },

      submitFormSender: async (formEl) => {
        console.log(dataForm.cargoInformation.numberOfIdenticalLoads);
        const isValideForm = await formEl.validate((valid) => valid);

        if (!isValideForm) {
          for (let i = 0; i < formTabs.tabs.length; i++) {
            if (!(await checkValidTab(formTabs.arrayFormTads[Object.keys(formTabs.arrayFormTads)[i]]))) {
              formTabs.activeName = formTabs.tabs[i];
              return;
            }
          }
          // formTabs
          return;
        }

        const check = (value) => (value === 'Наличные' ? 0 : 1);

        const typePickup = check(dataForm.payment.typeOfPaymentForCargoPickup);
        const typeTransportation = check(dataForm.payment.typeOfPaymentForCargoTransportation);
        const typeDelivery = check(dataForm.payment.typeOfPaymentForCargoDelivery);
        const typeExtraPacking = dataForm.cargoInformation.additionalPackaging ? check(dataForm.payment.typeOfPaymentForCargoExtraPacking) : typeTransportation;

        function generateObligation() {
          return {
            ptAddrPickUp: typePickup,
            ptGasolinePickUp: typePickup,
            ptCarrying: typeTransportation,
            ptAddrDelivery: typeDelivery,
            ptGasolineDelivery: typeDelivery,
            ptPacking: typeExtraPacking,
          };
        }

        function generateObligationPattern(isControgent) {
          const isWhoPayPickup = dataForm.payment.whoPaysForCargoPickup === isControgent;
          const isWhoPayTransportation = dataForm.payment.whoPaysForCargoTransportation === isControgent;
          const isWhoPayDelivery = dataForm.payment.whoPaysForCargoDelivery === isControgent;
          const isWhoPayExtraPacking = dataForm.cargoInformation.additionalPackaging ? dataForm.payment.whoPaysForCargoExtraPacking === isControgent : isWhoPayTransportation;

          const type = isWhoPayPickup ? typePickup : isWhoPayTransportation ? typeTransportation : isWhoPayDelivery ? typeDelivery : isWhoPayExtraPacking ? typeExtraPacking : 1;
          return {
            // addrPickUp: isWhoPayPickup,
            // gasolinePickUp: isWhoPayPickup,
            // waitingPickUp: isWhoPayPickup,
            // carrying: isWhoPayTransportation,
            // returnDocs:
            //   dataForm.services.returnOfDocuments && isWhoPayTransportation,
            // ptReturnDocs: typeTransportation,
            // addrDelivery: isWhoPayDelivery,
            // waitingDelivery: isWhoPayDelivery,
            // gasolineDelivery: isWhoPayDelivery,
            // packing: isWhoPayExtraPacking,
            // warmPlace: isWhoPayExtraPacking,
            // ptAddrPickUp: typePickup,
            // ptGasolinePickUp: typePickup,
            // ptWaitingPickUp: typePickup,
            // ptCarrying: typeTransportation,
            // ptAddrDelivery: typeDelivery,
            // ptGasolineDelivery: typeDelivery,
            // ptWaitingDelivery: typeDelivery,
            // ptPacking: typeExtraPacking,
            // ptWarmPlace: typeExtraPacking,
            // insuranceForValue: isWhoPayTransportation,
            // ptInsuranceForValue: typeTransportation,

            addrPickUp: isWhoPayPickup,
            gasolinePickUp: isWhoPayPickup,
            waitingPickUp: isWhoPayPickup,
            carrying: isWhoPayTransportation,
            returnDocs: dataForm.services.returnOfDocuments && isWhoPayTransportation,
            ptReturnDocs: type,
            addrDelivery: isWhoPayDelivery,
            waitingDelivery: isWhoPayDelivery,
            gasolineDelivery: isWhoPayDelivery,
            packing: isWhoPayExtraPacking,
            warmPlace: isWhoPayExtraPacking,
            ptAddrPickUp: type,
            ptGasolinePickUp: type,
            ptWaitingPickUp: type,
            ptCarrying: type,
            ptAddrDelivery: type,
            ptGasolineDelivery: type,
            ptWaitingDelivery: type,
            ptPacking: type,
            ptWarmPlace: type,
            insuranceForValue: isWhoPayTransportation,
            ptInsuranceForValue: type,
          };
        }

        function getBreakTime(time) {
          if (!time) {
            return;
          }
          const today = new Date();
          today.setHours(Number(time.slice(0, 2)), Number(time.slice(3, 5)));
          return today.toISOString().slice(11, 19);
        }

        function getTypeOfCargo(type) {
          switch (type) {
            case 'Стандарт':
              return 'Standart';
            case 'Цилиндры':
              return 'Cylinder';
            case 'Шины':
              return 'Tires';
          }
        }

        function getTypeOfPackaging(types) {
          return {
            palletizing: types.indexOf('Паллетирование') != -1,
            stretchFilm: types.indexOf('Стретч-пленка') != -1,
            lathing: types.indexOf('Обрешётка') != -1,
            poddon: types.indexOf('Поддон') != -1,
            box25x18x10: types.indexOf('Коробка 25x18x10') != -1,
            box38x30x23: types.indexOf('Коробка 38x30x23') != -1,
            packet: types.indexOf('Пакет') != -1,
          };
        }

        const joinFullName = (surname, firstName, secondName) => `${surname} ${firstName} ${secondName}`;

        const body = {
          comment: dataForm.services.sendTo ? `(Данные на водителя ${dataForm.services.sendTo}) ${dataForm.applicationCargoPickup.comment}` : dataForm.applicationCargoPickup.comment,

          transportation: {
            cityFrom: dataForm.sender.cityFrom,
            cityTo: dataForm.consignee.cityTo,
          },

          cashOnDelivery: {
            sum: Number(dataForm.services.cashOnDeliverySum),
          },

          sender: {
            phone: parsePhoneNumber(dataForm.sender.phoneSender),
            name: joinFullName(dataForm.sender.surnameSender, dataForm.sender.firstNameSender, dataForm.sender.secondNameSender),
            email: dataForm.sender.emailSender,
            corpClient: {
              inn: dataForm.sender.innSender,
              title: dataForm.sender.name,
              fullTitle: dataForm.sender.nameSender,
            },
            obligation: {
              ...generateObligation(),
            },
            obligationPattern: {
              comissionForCashOnDelivery: dataForm.services.cargoRedemption,
              ...generateObligationPattern('Отправитель'),
            },
          },

          documentReturn: dataForm.services.returnOfDocuments,

          repurchaseCargo: dataForm.services.cargoRedemptionSum
            ? {
                sum: Number(dataForm.services.cargoRedemptionSum),
                whoRepurchaseCargo: dataForm.services.whoPaysTheRansom ? Number(dataForm.services.whoPaysTheRansom) : 0,
              }
            : null,

          consignee: {
            phone: parsePhoneNumber(dataForm.consignee.phoneConsignee),
            name: joinFullName(dataForm.consignee.surnameConsignee, dataForm.consignee.firstNameConsignee, dataForm.consignee.secondNameConsignee),
            email: dataForm.consignee.emailConsignee,
            corpClient: {
              inn: dataForm.consignee.innConsignee,
              title: dataForm.consignee.name,
              fullTitle: dataForm.consignee.nameConsignee,
            },
            obligation: generateObligation(),
            obligationPattern: generateObligationPattern('Получатель'),
          },

          customer: {
            phone: parsePhoneNumber(dataForm.thirdPerson.phoneThirdPerson),
            name: joinFullName(dataForm.thirdPerson.surnameThirdPerson, dataForm.thirdPerson.firstNameThirdPerson, dataForm.thirdPerson.secondNameThirdPerson),
            email: dataForm.thirdPerson.emailThirdPerson,
            corpClient: {
              inn: dataForm.thirdPerson.innThirdPerson,
              title: dataForm.thirdPerson.name,
              fullTitle: dataForm.thirdPerson.name,
            },
            obligation: generateObligation(),
            obligationPattern: generateObligationPattern('Третье лицо'),
          },

          pickUp: null,

          delivery: !dataForm.applicationCargoPickup.deliveryToTheAddress
            ? null
            : {
                address: {
                  city: dataForm.consignee.cityTo,
                  address: dataForm.applicationCargoPickup.addressConsignee,
                },
                deliveryFrom: getTime(new Date('1970-07-07'), dataForm.applicationCargoPickup.cargoStartTimeDelivery),
                deliveryTo: getTime(new Date('1970-07-07'), dataForm.applicationCargoPickup.cargoEndTimeDelivery),
                deliveryBreakFrom: getBreakTime(dataForm.applicationCargoPickup.startTimeLunchBreakDelivery),
                deliveryBreakTo: getBreakTime(dataForm.applicationCargoPickup.endTimeLunchBreakDelivery),
              },

          value: Number(dataForm.cargoInformation.cargoCost),
          cargoList: new Array(Number(dataForm.cargoInformation.numberOfIdenticalLoads)).fill({
            cargoDescription: dataForm.cargoInformation.natureOfCargo,
            typeOfCargo: getTypeOfCargo(dataForm.cargoInformation.typeOfCargo),
            value: Number(dataForm.cargoInformation.cargoCost),
            weight: dataForm.cargoInformation.cargoWeight ? Number(dataForm.cargoInformation.cargoWeight) : 14.0,
            ...getTypeOfPackaging(dataForm.cargoInformation.typeOfPackaging),
            numberOfIdenticalLoads: 1,
            warmPlace: dataForm.services.warmPlace,
            sizeOfCargoBox:
              getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) === 'Standart'
                ? parseObjectInNumber({
                    length: dataForm.cargoInformation.cargoDimensions.length ? dataForm.cargoInformation.cargoDimensions.length : 43,
                    width: dataForm.cargoInformation.cargoDimensions.width ? dataForm.cargoInformation.cargoDimensions.width : 21,
                    height: dataForm.cargoInformation.cargoDimensions.height ? dataForm.cargoInformation.cargoDimensions.height : 39,
                  })
                : null,
            sizeOfCargoCylinder:
              getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) === 'Standart'
                ? null
                : getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) === 'Tires'
                ? { tire: true }
                : { ...dataForm.cargoInformation.sizeOfCargoCylinder },
          }),
        };

        if (!(dataForm.thirdPerson.cargoTransportationCustomer === 'Третье лицо')) {
          const obligation = { ...body.customer.obligation };
          const obligationPattern = { ...body.customer.obligationPattern };
          body.customer = dataForm.thirdPerson.cargoTransportationCustomer === 'Отправитель' ? { ...body.sender } : { ...body.consignee };
          body.customer.obligation = obligation;
          body.customer.obligationPattern = obligationPattern;
        }

        console.log('body = ', body);
        const params = {
          number: '034',
        };

        try {
          const { data } = await BACKEND.post(`/order/site?userid=${USER_ID}`, body, { params });
          console.log(data);
          passDataPrint(data, dataForm.thirdPerson.cargoTransportationCustomer, body);
          // formEl.resetFields();
          // formEl.clearValidate();
        } catch (e) {
          console.log(e);
        }
      },
      onPrint: async function () {
        const bodyCalc = {
          cityFrom: alertOfApplicationSubmission.sender.city,
          cityTo: alertOfApplicationSubmission.consignee.city,
          cargoSpace: [
            {
              cargoType: 'Standart',
              attachmentCount: 1,
            },
          ],
          cargoDeclaredValue: Number(alertOfApplicationSubmission.cargoCost),
          cargoRedemptionAmount: Number(alertOfApplicationSubmission.cargoRedemptionSum),
          cashOnDeliveryAmount: Number(alertOfApplicationSubmission.cashOnDelivery),
          returnOfDocuments: alertOfApplicationSubmission.documentReturn,
        };

        (async function () {
          try {
            const { data } = await BACKEND.post(`/calc?userid=${USER_ID}`, bodyCalc);
            pagePrint(data);
          } catch (e) {
            console.log(e);
          }
        })();
      },
      onMarkingCardPrint,
    };
  },
};
